{
  "AUDIT_LOGS": {
    "HEADER": "Логи аудиту",
    "HEADER_BTN_TXT": "Додати логи",
    "LOADING": "Завантаження логів",
    "DESCRIPTION": "Audit Logs maintain a record of activities in your account, allowing you to track and audit your account, team, or services.",
    "LEARN_MORE": "Learn more about audit logs",
    "SEARCH_404": "Немає елементів, що відповідають запиту",
    "SIDEBAR_TXT": "<p><b>Логи аудиту</b> </p><p> Логи - це історія всіх подій в системі. </p>",
    "LIST": {
      "404": "У цьому акаунті немає логів.",
      "TITLE": "Керувати логами",
      "DESC": " Логи - це історія всіх подій в системі.",
      "TABLE_HEADER": {
        "ACTIVITY": "Користувач",
        "TIME": "Дія",
        "IP_ADDRESS": "IP-адреса"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "Логи успішно отримано",
      "ERROR_MESSAGE": "Не вдалося підключитися до Woot Server, спробуйте ще раз пізніше"
    },
    "DEFAULT_USER": "Система",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} created a new automation rule (#{id})",
      "EDIT": "{agentName} updated an automation rule (#{id})",
      "DELETE": "{agentName} deleted an automation rule (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} запросив {invitee} на акаунт як {role}",
      "EDIT": {
        "SELF": "{agentName} змінив свій {attributes} на {values}",
        "OTHER": "{agentName} змінив {attributes} {user} на {values}",
        "DELETED": "{agentName} changed {attributes} of a deleted user to {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} created a new inbox (#{id})",
      "EDIT": "{agentName} updated an inbox (#{id})",
      "DELETE": "{agentName} deleted an inbox (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} created a new webhook (#{id})",
      "EDIT": "{agentName} updated a webhook (#{id})",
      "DELETE": "{agentName} deleted a webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "Увійшов {agentName}",
      "SIGN_OUT": "Вийшов {agentName}"
    },
    "TEAM": {
      "ADD": "{agentName} created a new team (#{id})",
      "EDIT": "{agentName} updated a team (#{id})",
      "DELETE": "{agentName} deleted a team (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} created a new macro (#{id})",
      "EDIT": "{agentName} updated a macro (#{id})",
      "DELETE": "{agentName} deleted a macro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} added {user} to the inbox(#{inbox_id})",
      "REMOVE": "{agentName} removed {user} from the inbox(#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} added {user} to the team(#{team_id})",
      "REMOVE": "{agentName} removed {user} from the team(#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} updated the account configuration (#{id})"
    },
    "CONVERSATION": {
      "ADD": "{agentName} створив розмову (#{id})",
      "EDIT": "{agentName} оновив розмову (#{id}): {changes}"
    },
    "CONTACT": {
      "ADD": "{agentName} створив контакт (#{id})",
      "EDIT": "{agentName} оновив контакт (#{id}): {attributes}"
    }
  }
}
